export const ADMIN_ROLES = [
  'Hr',
  'ProjectManager',
  'AdminController',
  'Distributor',
  'Adminsubscriptionuser',
  'Intern',
];

/** Roles that can access subscription-admin module (when login returns subscriptionAdmin). */
export const SUBSCRIPTION_ADMIN_ROLES = ADMIN_ROLES.filter((r) => r !== 'Intern');

/** Roles allowed to create new admins. */
export const ADMIN_CREATE_ROLES = ['Hr', 'AdminController'];

export const ADMIN_ROLE_LABELS = {
  Hr: 'HR',
  ProjectManager: 'Project Manager',
  AdminController: 'Admin Controller',
  Distributor: 'Distributor',
  Adminsubscriptionuser: 'Subscription Admin',
  Intern: 'Intern',
};

export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function isValidDateString(value) {
  return DATE_REGEX.test(value) && !Number.isNaN(Date.parse(value));
}

export function getRoleLabel(role) {
  return ADMIN_ROLE_LABELS[role] || role || '—';
}

export function isAdminProfileIncomplete(admin) {
  return !admin?.dateOfJoin || !admin?.qualification;
}
